import { observable } from "mobx";
import type { EntityValidationRules } from "../../services/validationService";

export default class EmailBlacklistFilter {
  @observable
  emailAddressSearchPattern?: string;

  @observable
  description?: string;

  @observable
  emailAddress?: string;
}

export const EmailBlacklistFilterValidationRules: EntityValidationRules<EmailBlacklistFilter> = {
  emailAddressSearchPattern: {
    isLength: { min: 3, max: 300, optional: true },
    isValidRegex: { required: false },
  },
  description: {
    isLength: { min: 3, max: 500, optional: true },
  },
  emailAddress: {
    isLength: { max: 254, optional: true },
    isSimpleEmail: { required: false },
  },
};
